import { render, staticRenderFns } from "./PontoSigDetalhe.vue?vue&type=template&id=f22e02e2&scoped=true&"
import script from "./PontoSigDetalhe.vue?vue&type=script&lang=js&"
export * from "./PontoSigDetalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22e02e2",
  null
  
)

export default component.exports